import { getCurrentInstance, onBeforeUnmount, ref } from 'vue'

export function useAutosave({ fingerprint, persist, delay = 800 }) {
  const pending = ref(false)
  const failed = ref(null)
  let saved = null
  let timer = null
  let running = null

  const dirty = () => saved !== null && fingerprint() !== saved

  const flush = async () => {
    clearTimeout(timer)
    timer = null
    while (running) await running
    if (!dirty()) {
      pending.value = false
      return
    }

    const sent = fingerprint()
    pending.value = true
    running = Promise.resolve()
      .then(persist)
      .then(baseline => {
        saved = baseline ?? sent
        failed.value = null
      })
      .catch(error => {
        failed.value = error
      })
    await running
    running = null

    if (!failed.value && dirty()) return flush()
    pending.value = timer !== null
  }

  const schedule = () => {
    if (!dirty()) return
    pending.value = true
    clearTimeout(timer)
    timer = setTimeout(flush, delay)
  }

  const reset = () => {
    clearTimeout(timer)
    timer = null
    saved = fingerprint()
    pending.value = false
    failed.value = null
  }

  if (getCurrentInstance()) onBeforeUnmount(() => timer && flush())

  return { pending, failed, schedule, flush, reset }
}
